import {
  clearStableRequest,
  createStableRequestId,
  getBrowserStorage,
  getOrCreateRequestByStorageKey,
} from '../../../../services/stableRequestId'

const STORAGE_PREFIX = 'specific:historical-ambient-request'

const getSessionStorage = () => getBrowserStorage('sessionStorage')

export const createAmbientRequestId = createStableRequestId

export const buildAmbientRequestStorageKey = ({
  landId,
  operation,
  monthRange,
  yearsList,
  countAmbients,
  basis,
}) => {
  const descriptor = JSON.stringify({
    landId: String(landId),
    operation,
    monthRange: [...monthRange],
    yearsList: [...yearsList].map(Number).sort((left, right) => left - right),
    countAmbients: Number(countAmbients),
    ...(basis ? {basis} : {}),
  })

  return `${STORAGE_PREFIX}:${encodeURIComponent(descriptor)}`
}

export const getOrCreateAmbientRequest = (
  descriptor,
  storage = getSessionStorage(),
  createId = createAmbientRequestId
) => {
  return getOrCreateRequestByStorageKey(
    buildAmbientRequestStorageKey(descriptor),
    storage,
    createId
  )
}

export const clearAmbientRequest = (storageKey, storage = getSessionStorage()) => {
  clearStableRequest(storageKey, storage)
}
